import { types, actions } from './requests'
export const CREATEPRODUCT_TYPES = {
    ...types('CREATEPRODUCT'),
}
export const CREATEPRODUCT_ACTIONS = {
    ...actions('CREATEPRODUCT'),
}
